// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_1lw_k"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/profile-actions-upper-part/profile-actions-upper-part.scss
// module id = 936
// module chunks = 3 4 5 6 7